export function  paginationScrollTo(selector){

    let containerTop = document.querySelector(selector).getBoundingClientRect().top
    containerTop += pageYOffset

    window.scrollTo({
        top: (containerTop - 100),
        behavior: "smooth"
    })

}

